window.validation = ( function() {
  console.log("js/validation.js -> v0.1.4 -> window.validation");

	return {
		/**
		 * Finds the closest parent matching the selector given
		 * @param {object} element
		 * @param {string} sel
		 */

		findAncestor: function(element, sel) {
			while ((element = element.parentElement) && !((element.matches || element.matchesSelector).call(element,sel)));
			return element;
		},


		/**
		 * Sets the validation state to an html element (adds the correct class)
		 * @param {object} element
		 * @param {boolean} validates
		 * @param {boolean} succesOutput
		 * @param {boolean} errorOutput
		*/

		setValidation: function(element, validates, successOutput = true, errorOutput = true) {
			if (validates && successOutput) {
				element.classList.remove('error');
				element.classList.add('success');
			}

			if (!validates && errorOutput) {
				element.classList.remove('success');
				element.classList.add('error');
			}
		},

		/* PATTERN MATCHING FUNCTIONS */

		/**
		 * returns true if current value is same or longer
		 * @param {string} value
		 * @param {int} length
		 * @return {boolean} true / false
		 */

		isMinimalLength: function(value, length) {
			return value.length >= length;
		},

		/**
		 * returns true if the value contains uppercase character(s)
		 * @param {string} value
		 * @return {boolean} true / false
		 */

		containsUppercaseCharacters: function(value) {
			return /([A-Z])+/.test(value);
		},

		/**
		 * returns true if the value contains lowercase character(s)
		 * @param {string} value
		 * @return {boolean} true / false
		 */

		containsLowercaseCharacters: function(value) {
			return /([a-z])+/.test(value);
		},

		/**
		 * returns true if the value contains numbers
		 * @param {string} value
		 * @return {boolean} true / false
		 */

		containsNumbers: function(value) {
			return /\d/.test(value);
		},

		/**
		 * returns true if both values are the same
		 * @param {string} value
		 * @param {string} secondValue
		 */
		containsSameValue: function(value, secondValue) {
			return value === secondValue;
		},

		/**
		 * returns true if the email is valid
		 * @param {string} email
		 */

		isValidEmail: function(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase().trim());
		},

		/* FIELD TYPE VALIDATION */

		/**
		 * @param {object} element
		 * @param {String} elementWrapper - wrapper selector
		 * @param {boolean} successOutput - optional
		 * @param {boolean} errorOutput - optional
		 */

		simpleValidation: function(element, elementWrapper, successOutput, errorOutput) {
			let wrapper = validation.findAncestor(element, elementWrapper);

			if (typeof element.value === 'string') {
				element.value.trim();
			}

			if (element.value == '') {
				validation.setValidation(wrapper, false, successOutput, errorOutput);
			}
			else {
				validation.setValidation(wrapper, true, successOutput, errorOutput);
			}
		},

		/**
		 * validate the email field
		 * @param {string} email
		 * @param {String} selector - wrapper selector
		 * @param {boolean} successOutput - optional
		 * @param {boolean} errorOutput - optional
		 */

		emailValidation: function(email, elementWrapper, successOutput, errorOutput) {
			let wrapper = validation.findAncestor(email, elementWrapper);

			if (!validation.isValidEmail(email.value)) {
				validation.setValidation(wrapper, false, successOutput, errorOutput);
			}
			else {
				validation.setValidation(wrapper, true, successOutput, errorOutput);
			}
		},

		/**
		 * Full check if the password validates on all conditions
		 * @param {String} password
		 * @param {String} selector - wrapper selector
		 * @param {boolean} successOutput - optional
		 * @param {boolean} errorOutput - optional
		 */

		isPasswordValid: function(password, elementWrapper, successOutput, errorOutput) {
			let wrapper = validation.findAncestor(password, elementWrapper);

			// take the password and run it through all the checks
			var checkLength = validation.isMinimalLength(password.value, 8);
			var checkNumbers = validation.containsNumbers(password.value);
			var checkUppercase = validation.containsUppercaseCharacters(password.value);
			var checkLowercase = validation.containsLowercaseCharacters(password.value);

			Promise.all([checkLength, checkNumbers, checkUppercase, checkLowercase])
			.then(function(values) {
				/*
				 * check if any of the values returns false
				 * if that is the case, the value would be true
				 * but negating that instantly to not have hack our way around
				 * the setValidation function
				 */
				let validates = !values.includes(false);

				validation.setValidation(wrapper, validates, successOutput, errorOutput);
  			});
		},

		/**
		 * check if the form itselfs contains any fields with errors
		 * @param {string} selector
		 * @return {boolean}
		 */

		hasFormErrors: function(form) {
			const formElement = document.querySelector(form);

			if (formElement.querySelector('.form-group.error') !== null) {
				return true;
			}
			else {
				return false;
			}
		},


    /**
     * takes an input and strips everything from it except numbers
     * Also leaves the comma and the period.
     */

    stripLetters: function(input) {
      let value = input.toString().replace(/[^0-9,.]+/gi, '');
      return value;
    },


		/**
		 * clear validation state
		 */

		clear: function() {
			const elements = document.querySelectorAll('.form-group');

			for (var i = 0; i < elements.length; i++) {
				elements[i].classList.remove('success', 'error');

				// also remove the success / error classes from children
				let children = elements[i].querySelectorAll('.success, .error');

				for (var j = 0; j < children.length; j++) {
					children[j].classList.remove('success', 'error');
				}
			}
		},

		/**
		 * reset a multi-step form
		*/
		resetSteps: function() {
			let elements = document.querySelectorAll('.steps .step');
			let bodies = document.querySelectorAll('.plt-modal .modal-body');

			for (var i = 0; i < elements.length; i++) {
				elements[i].classList.remove('move-in', 'move-out');
			}

			for (var j = 0; j < bodies.length; j++) {
				bodies[j].removeAttribute('style');
			}
		},

		/**
		 * clear the whole form
		 */

		clearFull: function(element) {
			const form = document.querySelector(element);

			if (form !== null) {
				form.reset();
				validation.clear();
				validation.resetSteps(form);
			}
		}
	}
})();
